/** Stylovyze ApplicationWrapper shell ids (see @innovyze/stylovyze). */
export const INNO_APP_ID = 'inno-app';
export const INNO_APP_BODY_ID = 'inno-app-body';
export const EMBED_HEIGHT_STYLE_ID = 'bernoulli-embed-height-fix';

const HEADER_USER_CONTEXT_SELECTOR = '[data-cy="header-user-context"]';

/**
 * Resolves the Stylovyze top header inside `#inno-app`.
 * Prefer the sibling immediately before `#inno-app-body`; fall back to the
 * header bar that contains the user-context control.
 */
export function findStylovyzeAppHeader(root: ParentNode = document): HTMLElement | null {
  const appShell = root.querySelector(`#${INNO_APP_ID}`);
  if (!appShell) {
    return null;
  }

  const appBody = appShell.querySelector(`#${INNO_APP_BODY_ID}`);
  const siblingHeader = appBody?.previousElementSibling;
  if (siblingHeader instanceof HTMLElement) {
    return siblingHeader;
  }

  const userContext = appShell.querySelector(HEADER_USER_CONTEXT_SELECTOR);
  let node: Element | null = userContext;
  while (node && node.parentElement && node.parentElement.id !== INNO_APP_ID) {
    node = node.parentElement;
  }
  return node instanceof HTMLElement ? node : null;
}

export function buildEmbedChromeStyleText(): string {
  return `
      html, body, #root, #${INNO_APP_ID} { height: 100% !important; overflow: hidden !important; }
      #${INNO_APP_BODY_ID},
      #${INNO_APP_BODY_ID} > *,
      #${INNO_APP_BODY_ID} > * > * { height: 100% !important; min-height: 0 !important; }
    `;
}

export type EmbedChromeCleanup = () => void;

/** Hide Stylovyze header chrome and stretch embed content to the iframe viewport. */
export function applyEmbedChrome(root: ParentNode = document): EmbedChromeCleanup {
  const header = findStylovyzeAppHeader(root);
  if (header) {
    header.style.setProperty('display', 'none', 'important');
  }

  let style = root instanceof Document ? root.getElementById(EMBED_HEIGHT_STYLE_ID) : null;
  if (!style && root instanceof Document) {
    style = root.createElement('style');
    style.id = EMBED_HEIGHT_STYLE_ID;
    style.textContent = buildEmbedChromeStyleText();
    root.head.appendChild(style);
  }

  return () => {
    if (root instanceof Document) {
      root.getElementById(EMBED_HEIGHT_STYLE_ID)?.remove();
    }
    if (header) {
      header.style.removeProperty('display');
    }
  };
}
